import { render } from "./TypesEdit.vue?vue&type=template&id=4e2a6d78&scoped=true"
import script from "./TypesEdit.vue?vue&type=script&lang=js"
export * from "./TypesEdit.vue?vue&type=script&lang=js"

import "./TypesEdit.vue?vue&type=style&index=0&id=4e2a6d78&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2a6d78"]])

export default __exports__